import React from 'react'

class Input extends React.Component {

    constructor(props){
        super(props);

        this.state={
            value: undefined
        }
    }

    render() {
        return (
            <div style={{...this.props.style}}>
                <div className={("js-floating-label ci-floating-label js-input-validation ci-input-validation ci-input") + (this.state.value || this.props.value ? " ci-label-floating" : "") + (this.props.isDisabled ? " ci-disabled" : "")} data-test="" data-error-message="">
                    <input type={this.props.type ? this.props.type : "text"} className="ci-input-element" value={ this.props.value }
                        onChange={(u) => { this.setState({ value: u.target.value }); this.props.onClick && this.props.onClick(u.target.value) }}
                        onKeyDown={(e) => { this.props.onKeyDown && this.props.onKeyDown(e) }}
                    />
                    <label htmlFor="input_input1">
                        {this.props.label ? this.props.label : ""}
                    </label>
                    <div className="ci-validation-status js-status-message"></div>
                </div>
            </div>
        )
    }
}

export default Input